$(document).ready(function () {
  const pageSelect = $('.side-navigation .menu__mobile .page-select__select');
  const pageSelectList = $('.side-navigation .menu__mobile .page-select__select option');

  if (pageSelect.length > 0) {
    window.addEventListener('pageshow', function (event) {
      setTimeout(() => {
        pageSelect.val($(pageSelectList.toArray().find((el) => $(el).attr('selected'))).val());
        if (pageSelect[0].selectedOptions.length == 0) {
          pageSelect[0].options[0].selected = true;
        }
      }, 10);
    });

    pageSelect.off('change').on('change', (e) => {
      window.location.assign(e.target.value);
    });
  }
});
